import Swiper from 'swiper'
import { EffectCards, EffectFade, Navigation } from 'swiper/modules'

import { buildComponent } from '#components'

const TestimonialsV2 = buildComponent({
  name: 'testimonials-v2',
  onConnected: (component) => {
    const contentEl = component.querySelector('.js-swiper-content') as HTMLElement
    const imagesEl = component.querySelector('.js-swiper-images') as HTMLElement
    const indicatorEl = component.querySelector('.js-swiper-indicator') as HTMLElement
    const nextEl = component.querySelector('.swiper-button-next') as HTMLElement
    const prevEl = component.querySelector('.swiper-button-prev') as HTMLElement

    if (contentEl && imagesEl) {
      const imagesSwiper = new Swiper(imagesEl, {
        modules: [EffectCards],
        effect: 'cards',
        slidesPerView: 'auto',
        centeredSlides: true,
        cardsEffect: {
          slideShadows: true,
          rotate: false,
          perSlideRotate: 0,
          perSlideOffset: 35
        },
        grabCursor: true,
        mousewheel: {
          invert: false
        },
        loop: false,
        on: {
          slideChange: function (swiper) {
            if (contentSwiper) {
              contentSwiper.slideTo(swiper.activeIndex)
            }
          }
        }
      })
      const contentSwiper = new Swiper(contentEl, {
        modules: [Navigation, EffectFade],
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl
        },
        loop: false,
        on: {
          slideChange: function (swiper) {
            const currentIndex = swiper.activeIndex + 1
            const totalSlides = swiper.slides.length

            if (indicatorEl) {
              indicatorEl.textContent = `${currentIndex}/${totalSlides}`
            }

            if (imagesSwiper) {
              imagesSwiper.slideTo(swiper.activeIndex)
            }
          }
        }
      })
    }
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'testimonials-v2': typeof TestimonialsV2
  }
}
